import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { StyleSheet, Text, TouchableHighlight, TouchableOpacity, TextProps, Image, ImageProps, ImageBackground, View } from 'react-native';
import { GenericTouchableProps } from 'react-native-gesture-handler/lib/typescript/components/touchables/GenericTouchable';
import { useDimensions, useHover } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectHovered, setHover } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { parseRequire } from '../../utils/parseImageUrl';
import { MenuOptions } from './SideBar';
interface MenuButtonProps {
    touchable: GenericTouchableProps,
    text?: MenuOptions,
    image?: ImageProps,
    children?: React.ReactNode;
}

export const MenuButton: React.FC<MenuButtonProps> = ({ touchable, image, text, children }) => {
    const ref = useRef(null);
    const isHovered = useHover(ref);
    const dispatch = useAppDispatch();
    const { width, height } = useDimensions().window;

    const styles = StyleSheet.create({
        touchable: {
            flex: 1,
            width: "100%",
            // aspectRatio: 623 / 172,


            zIndex: 999,
            opacity: 1,
            transform: [{
                scale: isHovered ? 1.1 : 1
            }
                , { scaleX: 1 }],
        }, buttonText: {
            zIndex: 1,
            fontFamily: "Ink Free",
            fontSize: useFontSize(6),
            fontWeight: "bold",
            color: "white",
            textAlign: "center",
            textShadowColor: "#E91E63",
            textShadowRadius: 4,
            textShadowOffset: { width: 2, height: 2 },
            // letterSpacing: 3
        },

    });

    return (
        <View style={styles.touchable}>
            <TouchableOpacity ref={ref}  {...touchable}>
                {image ? <Image style={{ width: "100%", height: "100%" }} resizeMode={'contain'} {...image}></Image> : <></>}
                <ImageBackground style={{ width: "100%", position: "absolute", opacity: isHovered ? 100 : 0 }} resizeMode={'contain'} source={parseRequire(require('@lss/common/game/assets/images/Menu/menu_hover.webp'))}>
                    <Text style={styles.buttonText}>{text}</Text>
                </ImageBackground>
                <Text style={styles.buttonText}>{text}</Text>
            </TouchableOpacity>
        </View>

    );
};